"use client";

import React from "react";
import Link from "next/link";
import AppLogo from "./ui/AppLogo";

// The Navbar is now global in RootLayout. 
// We keep the Footer here for landing pages.


export function Footer() {
  return (
    <footer className="py-12 border-t border-zinc-200 dark:border-zinc-800/30 bg-zinc-50 dark:bg-zinc-950 transition-colors duration-300">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <AppLogo size={24} />
              <span className="text-lg font-bold tracking-tight text-zinc-900 dark:text-white">TeraBox API</span>
            </div>
            <p className="text-zinc-500 dark:text-zinc-500 text-[11px] leading-relaxed max-w-[200px]">
              Reliable extraction infrastructure for the TeraBox ecosystem.
            </p>
          </div>
          <div>
            <h4 className="font-bold text-zinc-900 dark:text-zinc-300 mb-4 text-[10px] uppercase tracking-widest">Product</h4>
            <ul className="space-y-2 text-zinc-500 dark:text-zinc-500 text-xs">
              <li><Link href="/features" className="hover:text-blue-600 dark:hover:text-white transition-colors">Features</Link></li>
              <li><Link href="/pricing" className="hover:text-blue-600 dark:hover:text-white transition-colors">Pricing</Link></li>
              <li><Link href="/docs" className="hover:text-blue-600 dark:hover:text-white transition-colors">Docs</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-zinc-900 dark:text-zinc-300 mb-4 text-[10px] uppercase tracking-widest">Support</h4>
            <ul className="space-y-2 text-zinc-500 dark:text-zinc-500 text-xs">
              <li><a href="https://t.me/teraboxdl_api" className="hover:text-blue-600 dark:hover:text-white transition-colors">Telegram</a></li>
              <li><a href="mailto:mohdamir7505@gmail.com" className="hover:text-blue-600 dark:hover:text-white transition-colors">Email</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-zinc-900 dark:text-zinc-300 mb-4 text-[10px] uppercase tracking-widest">Legal</h4>
            <ul className="space-y-2 text-zinc-500 dark:text-zinc-500 text-xs">
              <li><a href="#" className="hover:text-blue-600 dark:hover:text-white transition-colors">Privacy</a></li>
              <li><a href="#" className="hover:text-blue-600 dark:hover:text-white transition-colors">Terms</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-zinc-200 dark:border-zinc-800/20 text-left text-[10px] text-zinc-400 dark:text-zinc-600 font-medium">
          &copy; 2026 TeraBox API. Mohammad Amir.
        </div>
      </div>
    </footer>
  );
}
